import React from "react";
import AsyncSelect from "react-select/async";
import { searchCars } from "../http"; 
import styles from "./CarSearchSelect.module.scss"; 

export const CarSearchSelect = ({
  onCarSelect,
  placeholder,
  currentCar,
}) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#80bdff",
      },
      borderRadius: "var(--input-border-radius)",
      padding: "0.5rem", 
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      zIndex: 5,
    }),
    placeholder: (base) => ({
      ...base,
      color: "#6c757d",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#495057",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#f1f4f8",
      color: "#495057",
      borderRadius: "var(--input-border-radius)", 
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#495057",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#d9534f",
      ":hover": {
        backgroundColor: "#f5c6cb",
        color: "#a94442",
      },
    }),
  };
  
  const loadCars = async (inputValue) => {
    try {
      const fetchedCars = await searchCars(inputValue); 
      return fetchedCars.map((car) => ({
        value: car.id,
        label: `${car.manufacturer} ${car.model} ${car.reg_number}`,
      }));
    } catch (error) {
      console.error("Error fetching cars:", error);
      return [];
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onCarSelect(selectedOption.value, selectedOption.label); 
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>{placeholder}</label>
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadCars}
        onChange={handleChange}
        placeholder={placeholder}
        styles={customStyles}
        value={currentCar && currentCar.id && currentCar.label ? { value: currentCar.id, label: currentCar.label } : null}
        />
    </div>
  );
};
